// Lazy loading for cell line data to reduce memory usage during build

const cellLineDataLoaders = {
  'Breast_BT-549': () => import('./Breast_BT-549.json'),
  'Breast_Hs-578T': () => import('./Breast_Hs-578T.json'),
  'Breast_MCF-7': () => import('./Breast_MCF-7.json'),
  'Breast_MDA-MB-231': () => import('./Breast_MDA-MB-231.json'),
  'Breast_MDA-MB-468': () => import('./Breast_MDA-MB-468.json'),
  'Breast_T-47D': () => import('./Breast_T-47D.json'),
  'CNS_SF-268': () => import('./CNS_SF-268.json'),
  'CNS_SF-295': () => import('./CNS_SF-295.json'),
  'CNS_SF-539': () => import('./CNS_SF-539.json'),
  'CNS_SNB-19': () => import('./CNS_SNB-19.json'),
  'CNS_SNB-75': () => import('./CNS_SNB-75.json'),
  'CNS_U251': () => import('./CNS_U251.json'),
  'Colon_COLO-205': () => import('./Colon_COLO-205.json'),
  'Colon_HCC-2998': () => import('./Colon_HCC-2998.json'),
  'Colon_HCT-116': () => import('./Colon_HCT-116.json'),
  'Colon_HCT-15': () => import('./Colon_HCT-15.json'),
  'Colon_HT29': () => import('./Colon_HT29.json'),
  'Colon_SW-620': () => import('./Colon_SW-620.json'),
  'Leukemia_CCRF-CEM': () => import('./Leukemia_CCRF-CEM.json'),
  'Leukemia_HL-60': () => import('./Leukemia_HL-60.json'),
  'Leukemia_K562': () => import('./Leukemia_K562.json'),
  'Leukemia_MOLT-4': () => import('./Leukemia_MOLT-4.json'),
  'Leukemia_RPMI-8226': () => import('./Leukemia_RPMI-8226.json'),
  'Leukemia_SR': () => import('./Leukemia_SR.json'),
  'Melanoma_LOX-IMVI': () => import('./Melanoma_LOX-IMVI.json'),
  'Melanoma_M14': () => import('./Melanoma_M14.json'),
  'Melanoma_MALME-3M': () => import('./Melanoma_MALME-3M.json'),
  'Melanoma_MDA-MB-435': () => import('./Melanoma_MDA-MB-435.json'),
  'Melanoma_SK-MEL-28': () => import('./Melanoma_SK-MEL-28.json'),
  'Melanoma_SK-MEL-2': () => import('./Melanoma_SK-MEL-2.json'),
  'Melanoma_SK-MEL-5': () => import('./Melanoma_SK-MEL-5.json'),
  'Melanoma_UACC-257': () => import('./Melanoma_UACC-257.json'),
  'Melanoma_UACC-62': () => import('./Melanoma_UACC-62.json'),
  'NSCL_A549': () => import('./NSCL_A549.json'),
  'NSCL_EKVX': () => import('./NSCL_EKVX.json'),
  'NSCL_HOP-62': () => import('./NSCL_HOP-62.json'),
  'NSCL_HOP-92': () => import('./NSCL_HOP-92.json'),
  'NSCL_NCI-H226': () => import('./NSCL_NCI-H226.json'),
  'NSCL_NCI-H23': () => import('./NSCL_NCI-H23.json'),
  'NSCL_NCI-H322M': () => import('./NSCL_NCI-H322M.json'),
  'NSCL_NCI-H460': () => import('./NSCL_NCI-H460.json'),
  'NSCL_NCI-H522': () => import('./NSCL_NCI-H522.json'),
  'Ovarian_ADR-RES': () => import('./Ovarian_ADR-RES.json'),
  'Ovarian_IGR-OV1': () => import('./Ovarian_IGR-OV1.json'),
  'Ovarian_OVCAR-3': () => import('./Ovarian_OVCAR-3.json'),
  'Ovarian_OVCAR-4': () => import('./Ovarian_OVCAR-4.json'),
  'Ovarian_OVCAR-5': () => import('./Ovarian_OVCAR-5.json'),
  'Ovarian_OVCAR-8': () => import('./Ovarian_OVCAR-8.json'),
  'Ovarian_SK-OV-3': () => import('./Ovarian_SK-OV-3.json'),
  'Prostate_DU145': () => import('./Prostate_DU145.json'),
  'Prostate_PC-3': () => import('./Prostate_PC-3.json'),
  'Renal_786-0': () => import('./Renal_786-0.json'),
  'Renal_A498': () => import('./Renal_A498.json'),
  'Renal_ACHN': () => import('./Renal_ACHN.json'),
  'Renal_CAKI-1': () => import('./Renal_CAKI-1.json'),
  'Renal_RXF-393': () => import('./Renal_RXF-393.json'),
  'Renal_SN12C': () => import('./Renal_SN12C.json'),
  'Renal_TK-10': () => import('./Renal_TK-10.json'),
  'Renal_UO-31': () => import('./Renal_UO-31.json')
};

export const getCellLineDataAsync = async (cellLine) => {
  const loader = cellLineDataLoaders[cellLine];
  if (!loader) return null;
  
  try {
    const module = await loader();
    return module.default;
  } catch (error) {
    console.error(`Failed to load cell line data for ${cellLine}:`, error);
    return null;
  }
};